import { NgModule } from "@angular/core";
import { SidenavComponent } from "./sidenav.component";

@NgModule({
  imports: [SidenavComponent],
  exports: [SidenavComponent],
})
export class SidenavComponentModule {}
